import cloneDeep from 'lodash/cloneDeep'
import {
    ADD_ACTORS,
    DELETE_ACTORS,
    UPDATE_ACTORS,
    DELAY_ACTOR,
    RESET_ACTORS_DELAY,
    RESET_ACTORS,
} from '../../actions/game/actor.actions'
import entityHelper from '../../../utils/entityHelper'
import { mergeObjects } from '../../../utils/helper'

const { getUnitData } = entityHelper
const initialState = []

const actorReducer = (state = initialState, action) => {
    const { payload } = action

    switch (action.type) {
        case ADD_ACTORS: {
            const { actors } = payload
            const newActors = actors.map(baseUnit => ({ ...getUnitData(baseUnit) }))
            return [
                ...cloneDeep(state),
                ...newActors,
            ]
        }

        case DELETE_ACTORS: {
            const { targets } = payload
            return cloneDeep(state).filter(actor => !targets.includes(actor.ID))
        }

        case UPDATE_ACTORS: {
            const { target, changedStatus } = payload

            return cloneDeep(state).map((actor) => {
                if (actor.ID === target.ID) {
                    const newStatus = mergeObjects(actor.status, changedStatus)
                    return { ...actor, status: newStatus }
                }
                return actor
            })
        }

        case DELAY_ACTOR: {
            const { target, delay } = payload

            return state.map(actor => (
                actor.ID === target
                    ? { ...actor, timeframe: actor.timeframe + delay }
                    : actor
            ))
        }

        case RESET_ACTORS_DELAY: {
            return cloneDeep(state).map(actor => ({ ...actor, timeframe: actor.initialTimeframe }))
        }

        case RESET_ACTORS: {
            return initialState
        }

        default: {
            return state
        }
    }
}

export default actorReducer
